import { FeaturedJobDetailResponse } from '@doda/api-client/aspida/@types';

/**
 * 表示用の注目求人データの型を定義するインターフェース
 */
export interface FeaturedJobsDisplay {
  /** 会社ID */
  corporateId: string;
  /** 会社名 */
  companyName: string;
  /** 各求人のリンクリスト */
  jobLinkList: {
    /** 求人詳細のURL */
    url: string;
    /** 求人のテキスト */
    text: string;
  }[];
}

/**
 * 注目求人データを表示用データに変換する関数
 * 求人情報を会社ごとにまとめる
 *
 * @param {FeaturedJobDetailResponse[]} featuredJobs - 注目求人データの配列
 * @returns {FeaturedJobsDisplay[]} 注目求人の表示用データの配列
 */
export const convertFeaturedJobsDisplayData = (
  featuredJobs: FeaturedJobDetailResponse[]
): FeaturedJobsDisplay[] => {
  const covertedData: FeaturedJobsDisplay[] = [];

  featuredJobs.forEach((featuredJob) => {
    const url =
      featuredJob.url +
      (featuredJob.jobManuscriptType === 'E' ? '-tab__pr/' : '');

    const sameCompanyDataIndex = covertedData.findIndex(
      (displayData) => displayData.corporateId === featuredJob.corporateId
    );

    if (
      featuredJob.corporateName === undefined ||
      featuredJob.occupationName === undefined ||
      featuredJob.corporateId === undefined
    )
      return;

    if (sameCompanyDataIndex > -1) {
      covertedData[sameCompanyDataIndex].jobLinkList.push({
        url,
        text: featuredJob.occupationName,
      });
      return;
    }

    covertedData.push({
      corporateId: featuredJob.corporateId,
      companyName: featuredJob.corporateName,
      jobLinkList: [
        {
          url,
          text: featuredJob.occupationName,
        },
      ],
    });
  });

  return covertedData;
};
